import { Modal } from "react-bootstrap";
import React from "react";
import styled from "styled-components";
import { Button } from "react-bootstrap";

import { BsQuestionLg } from "react-icons/bs";
import { MyModal } from "../../features/RadConnStyle";
export default function ModalDialog(props) {
  const handleClose = (value) => {
    props.setConfirm({ showConfirm: false, confirm: value });
    if (value === true) {
      props.action(props.confirm.data);
    }
  };

  return (
    <MyModal show={props.confirm.showConfirm}>
      <Modal.Header></Modal.Header>

      <Modal.Body>
        <MsgBox>
          กรุณายืนยันการยกเลิกรายการ <BsQuestionLg />
        </MsgBox>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="primary" onClick={() => handleClose(true)}>
          ยืนยัน
        </Button>
        <Button variant="danger" onClick={() => handleClose(false)}>
          ยกเลิก
        </Button>
      </Modal.Footer>
    </MyModal>
  );
}

const MsgBox = styled.p`
  font-size: large;
  color: #f8f2f2;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
`;
